import React from "react";

/**
 * A mobile company list item for contact's linked companies.
 */
export default function MobileCompanyItem({ company, onClick }) {
  return (
    <div className="mobile-company-item" onClick={onClick}>
      <div className="mobile-company-item__name">
        {company.company_id?.company_name || "Unknown Company"}
      </div>
      <div className="mobile-company-item__function">
        {company.function || "No function"}
      </div>
    </div>
  );
}

